import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import OrganizationQR from './components/Organization/OrganizationQR'
import EmployeesQR from './components/Employees/EmployeesQR'
import Tabs from './components/Tabs'
type QRTabs = 'organization' | 'employees'

const QRPage = () => {
    const {t} = useTranslation()
    const [currentTab, setCurrentTab] = useState<QRTabs>('organization')

    const onClickTab = (tab: QRTabs) => () => setCurrentTab(tab)

    return (
        <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-8 px-2 pt-9 xs:px-9">
            <Tabs>
                <Tabs.Tab
                    isSelected={currentTab === 'organization'}
                    onClick={onClickTab('organization')}
                >
                    {t('QR_TAB_ORGANIZATION')}
                </Tabs.Tab>
                <Tabs.Tab
                    isSelected={currentTab === 'employees'}
                    onClick={onClickTab('employees')}
                >
                    {t('QR_TAB_EMPLOYEES')}
                </Tabs.Tab>
            </Tabs>
            {currentTab === 'organization' ? (
                <OrganizationQR />
            ) : (
                <EmployeesQR />
            )}
        </div>
    )
}

export default QRPage
